import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=78a2a015&scoped=true"
import script from "./org-list.vue?vue&type=script&lang=js"
export * from "./org-list.vue?vue&type=script&lang=js"
import style0 from "./org-list.vue?vue&type=style&index=0&id=78a2a015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2a015",
  null
  
)

export default component.exports